import { lazy, type ComponentType } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Loader = () => Promise<{ default: ComponentType<any> }>;

const loaders: Loader[] = [];
let prefetched = false;

/** React.lazy que também entra na lista do prefetchScreens. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function lazyScreen<T extends ComponentType<any>>(load: () => Promise<{ default: T }>) {
  loaders.push(load);
  return lazy(load);
}

/**
 * Baixa o código de todas as telas quando o navegador fica ocioso, uma por vez.
 * Assim a primeira visita a um menu não espera o download. O navegador guarda o
 * resultado, e o lazy() reaproveita a mesma promessa do import.
 */
export function prefetchScreens() {
  if (prefetched) return;
  prefetched = true;
  const idle = (cb: () => void) =>
    'requestIdleCallback' in window ? window.requestIdleCallback(cb, { timeout: 3000 }) : setTimeout(cb, 1500);
  const queue = [...loaders];
  const next = () => {
    const load = queue.shift();
    if (!load) return;
    load().catch(() => { /* deploy novo trocou o chunk: a tela baixa quando for aberta */ }).finally(() => idle(next));
  };
  idle(next);
}
